/**
 * Runtime platform check.
 *
 * `isWeb` is true in a real browser (specforma.app) and false in the Electron
 * desktop shell. Use it to hide capabilities that only work on the desktop —
 * e.g. local/network filesystem access (Project Drive mapping, folder pickers).
 * Mirrors the API-origin resolution in lib/apiBase.ts (same UA test).
 */
export const isWeb = typeof navigator !== 'undefined' && !/electron/i.test(navigator.userAgent);
